import React from 'react';
import WizardItem, { IWizardItem } from '../WizardItem';
import styles from './WizardWrapper.module.scss';

interface Props {
	item: IWizardItem;
}

const WizardWrapper: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			<h1 className='mt-4 mb-md-5'>{item.title}</h1>
			{item?.children?.length && item.children.length > 0 && (
				<div className={styles.content}>
					{item.children.map((child, key) => (
						<React.Fragment key={key}>
							<WizardItem item={child} />
						</React.Fragment>
					))}
				</div>
			)}
		</div>
	);
};

export default WizardWrapper;
